import React from 'react';
import { Info } from 'lucide-react';

interface EmptyStateProps {
  title: string;
  subtitle?: string;
  showAdSpace?: boolean;
  className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ title, subtitle, className = '' }) => {
  return (
    <div
      data-test-id="empty-state"
      className={`flex flex-col items-center justify-center py-12 px-6 text-center ${className}`}
    >
      <div className="mb-4">
        <Info data-test-id="empty-state-icon" className="w-12 h-12 text-text-muted" />
      </div>

      <h3 data-test-id="empty-state-title" className="text-text-primary font-medium mb-2">
        {title}
      </h3>

      {subtitle && (
        <p data-test-id="empty-state-subtitle" className="text-text-secondary text-sm mb-6">
          {subtitle}
        </p>
      )}

      {/* {showAdSpace && (
        <div data-test-id="ad-space" className="mt-8">
          <div className="bg-app-surface rounded-lg px-6 py-3 border border-border/20">
            <span className="text-text-muted text-sm">Ad Space</span>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default EmptyState;
